export function buildCategoryTree(categories) {
    var children = {};
    for (var catId in categories) {
        if (!Object.prototype.hasOwnProperty.call(categories, catId)) continue;
        var cat = categories[catId];
        var parentId = (cat && cat.ParentId != null && cat.ParentId != catId) ? cat.ParentId : -1;
        if (!children[parentId]) {
            children[parentId] = [];
        }
        children[parentId].push(parseInt(catId, 10));
    }
    return children;
}

export function aggregateExpensesByMonth(expenses) {
    if (!Array.isArray(expenses)) return {};
    return expenses.reduce((rv, x) => {
        var key = (x && x.ExpenseStartDateUtc) ? x.ExpenseStartDateUtc.substring(0, 7) : 'Unknown';
        var categoryId = (x && x.CategoryId) || 0;
        rv[key] = rv[key] || {};
        rv[key][categoryId] = (rv[key][categoryId] || 0) + (x.Total || 0);
        return rv;
    }, {});
}

export function formatCurrency(amount) {
    if (amount == null || isNaN(amount)) return "$0.00";
    var num = Number(amount);
    return (num < 0 ? "-$" : "$") + Math.abs(num).toFixed(2);
}

export function computeCategoryRollup(categoryTree, monthlyData, rootCategoryId) {
    var total = 0;
    if (monthlyData && monthlyData[rootCategoryId]) {
        total += monthlyData[rootCategoryId];
    }
    var children = categoryTree[rootCategoryId] || [];
    for (var i = 0; i < children.length; i++) {
        total += computeCategoryRollup(categoryTree, monthlyData, children[i]);
    }
    return total;
}
